import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { DatasetNavigatorService } from 'app/main/components/dataset/services/dataset-navigator.service';
import { DatasetActionContainerService } from 'app/main/components/dataset/services/dataset-action-container.service';
import { AppService } from 'app/services/app.service';
import { DatasetService } from 'app/main/components/dataset/services/dataset.service';
import { DatasetRecordService } from 'app/main/components/dataset/services/dataset-record.service';

import tripBookingParticipantViewConfig from 'app/configs/datasets/trip_booking_services/participant-view-config';

@Component({
    selector: 'trip-booking-participant-item-view',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
    providers: [DatasetRecordService, DatasetActionContainerService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TripBookingParticipantItemViewComponent implements OnInit, OnChanges{

	@Input() parentDatasetACS: DatasetActionContainerService;
	@Input() item: any;
	@Output() delete: EventEmitter<void> = new EventEmitter();
	@Output() edit: EventEmitter<void> = new EventEmitter();
	@Output() selected: EventEmitter<any> = new EventEmitter();

	public viewConfig = tripBookingParticipantViewConfig;

	constructor(
		protected datasetService: DatasetService,
		protected appService: AppService,
		public datasetACS: DatasetActionContainerService,
		public datasetRS: DatasetRecordService,
		public datasetNavigatorService: DatasetNavigatorService
	){}

	ngOnInit(): void{}

	ngOnChanges(changes: SimpleChanges): void{
		this.datasetRS.record.next(this.item);
	}

	select(): void{
		this.selected.emit(this.item);
	}
}
